import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {BROWSERS, DeviceDetectorService} from 'ngx-device-detector';
import {ExpressDepositComponent} from '../express-deposit/express-deposit.component';
import {Subject} from 'rxjs';
import {UploadedFileType} from '../helpers/file-status.enum';
import {PostalAddress} from '../../../../model/postal-address';
import {AddressLine} from '../../../../model/address-line';
import {AddressService} from '../../../../services/apiServices/business/address.service';
import {KindOfUpload} from '../helpers/kind-of-upload.enum';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {DepositDepotExpressEnum} from "../../../../enums/deposit.enums";

const COUNTRY_TO_EXCLUDE = 'FRANCE';
const COUNTRY_LABEL_KEY = 'country';

@Component({
  selector: 'app-express-unit',
  templateUrl: './express-unit.component.html',
  styleUrls: ['./express-unit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpressUnitComponent implements OnInit {

  @ViewChild('addressTargetContainer', {static: false})
  addressTargetContainer: ElementRef;
  @ViewChild('addressDragContainer', {static: false})
  addressDragContainer: ElementRef;
  @Output() public modalDisplay: EventEmitter<boolean>;
  @Output() public shouldClearFiles: Subject<any>;
  public templateSource: string;
  public showMailingModelEditor: boolean;
  public externalLink: string;
  public mainFile: File;
  public signature: File;
  public principalFileValidity: boolean;
  public process: MenuItem[];
  public currentStep: string;
  public activeIndex = 0;
  public hasSignature: boolean;
  public depositDir;
  public userGrayColor: boolean = true;
  public customizedFilePdf;
  public displayLoading = false;
  public savingTrial = 1;
  public progressTimeout = null;
  public persistedCount: number;
  public depositPersisted = false;
  public depositPersistedSerialLot: number = null;
  public progressPersisted = 0;
  public pageCount = 0;
  public sigPages: any[];
  public pages: any[];
  public selectedPage = 0;
  public posX: number;
  public posY: number;
  public width: number;
  public height: number;
  public cWidth: number;
  public cHeight: number;
  public resultItems: string[];
  public userEditedAddress: boolean;
  public extractedAddress: PostalAddress;
  public addressToEdit: PostalAddress;
  public showEditAddress: boolean;
  public addressToEditLines: string[];
  public propertiesOfSelectedCountry: any;
  public addressItemsLabels: any;
  public selectedCountry: string;
  public formattedAddress: string[];
  public addressesLines: AddressLine[];
  public postalAddressLines: string[];
  public countryLabel: any;
  public containerBGStyle: any;
  public targetContainerStyle: any;
  public FileStatus = UploadedFileType;
  public pagesImages: any;
  public pdfToDisplay: any;
  public msBrowsers: boolean;
  public openVisualization: boolean;
  acceptedUtinFiles = [];

  constructor(private createDepositService: CreateDepositService, private translate: TranslateService,
              private commonService: CommonService, public addressService: AddressService,
              private deviceService: DeviceDetectorService) {
    this.modalDisplay = new EventEmitter<boolean>();
    this.shouldClearFiles = new Subject<any>();
  }

  ngOnInit() {
    this.userEditedAddress = false;
    this.acceptedUtinFiles = ['pdf', 'doc', 'odt', 'docx'];
    this.msBrowsers = (BROWSERS.IE === this.deviceService.getDeviceInfo().browser || BROWSERS.MS_EDGE === this.deviceService.getDeviceInfo().browser);
    this.currentStep = ExpressDepositComponent.PARAMS_STEP;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.TEMPLATE')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.PREVIEW')},
    ];
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.addressItemsLabels = {
        country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
      };
    } else {
      this.addressService.labelsReady.subscribe(val => {
        if (val === this.translate.currentLang) {
          this.addressItemsLabels = {
            country: JSON.parse(this.addressService.getLabelsForLang(this.translate.currentLang))
          };
        }
      });
    }
  }

  public nextEnabled(): boolean {
    if (this.currentStep === ExpressDepositComponent.PARAMS_STEP) {
      return true;
    } else if (this.currentStep === ExpressDepositComponent.TEMPLATE_STEP) {
      return this.extractedAddress && this.extractedAddress.isValid();
    } else if (this.currentStep === ExpressDepositComponent.FORMATTING_STEP) {
      return true;
    } else {
      return true;
    }
  }

  public nextStep() {
    switch (this.currentStep) {
      case ExpressDepositComponent.PARAMS_STEP:
        this.currentStep = ExpressDepositComponent.TEMPLATE_STEP;
        this.showModelBrowser();
        this.activeIndex++;
        break;
      case ExpressDepositComponent.TEMPLATE_STEP:
        this.storeRecipient();
        break;
      case ExpressDepositComponent.FORMATTING_STEP :
        /*if (this.hasSignature) {
          this.storeSignaturePosition();
        } else {
          this.prepareMailingFinalFile({page: 1});
        }*/
        break;
    }
  }
  showModelBrowser() {
    this.userEditedAddress = false;
    this.templateSource = 'USER_PDF';
    // this.doCreateNewModel();
  }
  openEditor() {
    this.userEditedAddress = true;
    this.showEditAddress = true;
    this.extractedAddress = new PostalAddress({});
    this.addressToEdit = this.extractedAddress;
    this.templateSource = 'LOOL_ODT';
    /*this.doCreateNewModel();*/
  }
  doCreateNewModel(addressLines: string[]) {
    this.createDepositService.createNewLOOLCustomerModel(this.depositDir, addressLines).subscribe(response => {
      if (response && response.externalLink) {
        this.externalLink = response.externalLink;
        this.showMailingModelEditor = true;
      }
    });
  }
  editorClosed() {
    this.createDepositService.getUnitCustomerModelPDF(this.depositDir).subscribe(response => {
      if (response.depositDir) {
        this.mainFile = response.mainFile;
        this.sigPages = [];
        this.pageCount = response.pageCount;
        this.pages = [];
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        this.pagesImages = {};
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_1'] + ')'
          };
          if (this.userEditedAddress) {
            this.nextStep();
          }
          else {
            setTimeout(() => {
              this.initAreaConfig();
            }, 100);
          }
        }
        this.showMailingModelEditor = false;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }
  public setMainFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      this.addExpressUnitMainFile(files[0]);
    } else {
      this.mainFile = null;
    }
  }

  private addExpressUnitMainFile(file: File) {
    const dataToSend = new FormData();
    dataToSend.append('main', file);
    dataToSend.append('depositDir', this.depositDir);
    this.createDepositService.addExpressMainFile(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.mainFile = file;
        this.depositDir = response.depositDir;
        this.pageCount = response.pageCount;
        this.sigPages = [];
        this.pages = [];
        this.pagesImages = {};
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_1'] + ')'
          };
          setTimeout(() => {
            this.initAreaConfig();
          }, 100);
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  public updateUploadValidity(fileType: string, validtyFromChild: boolean) {
    switch (fileType) {
      case UploadedFileType.MAIN:
        this.principalFileValidity = validtyFromChild;
        break;
    }
  }

  public setSignatureFile(file: File) {
    this.signature = file;
    this.setSignatureFlag(file !== null);
  }

  setSignatureFlag(event: boolean) {
    this.hasSignature = event;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.TEMPLATE')}
    ];
    if (this.hasSignature) {
      this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.FORMATTING')});
    }
    this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.UNIT.PREVIEW')});
  }

  setDepositDir(value) {
    this.depositDir = value;
  }

  public updateBG(pagination: any) {
    this.selectedPage = pagination.page + 1;
    if (this.pagesImages.hasOwnProperty('page_' + this.selectedPage)) {
      this.containerBGStyle = {
        'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
      };
    } else {
      if (this.mainFile) {
        this.createDepositService.getPageAsImage(this.depositDir, this.selectedPage).subscribe(response => {
          this.pagesImages['page_' + this.selectedPage] = response['page_' + this.selectedPage];
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
          };
        });
      }
    }
  }

  public initAreaConfig(): void {
    this.containerBGStyle = {
      'background-image': 'url(/assets/img/Document.jpg)'
    };
    this.posX = 105;
    this.posY = 48;
    this.width = 100;
    this.height = 47;
    this.updateBG({page: 0});
    setTimeout(() => {
      this.cWidth = this.addressDragContainer.nativeElement.clientWidth;
      this.cHeight = this.addressDragContainer.nativeElement.clientHeight;
      this.posX = this.posX * this.cWidth / 210;
      this.posY = this.posY * this.cHeight / 297;
      this.width = this.width * this.cWidth / 210;
      this.height = this.height * this.cHeight / 297;
      this.targetContainerStyle = {
        left: this.posX + 'px',
        top: this.posY + 'px',
        width: this.width + 'px',
        height: this.height + 'px'
      };
      this.extractRegion();
    }, 100);
  }

  public recalculateRegion(): void {
    this.posX = this.addressTargetContainer.nativeElement.getBoundingClientRect().left - this.addressDragContainer.nativeElement.getBoundingClientRect().left;
    this.posY = this.addressTargetContainer.nativeElement.getBoundingClientRect().top - this.addressDragContainer.nativeElement.getBoundingClientRect().top;
    this.width = this.addressTargetContainer.nativeElement.getBoundingClientRect().width;
    this.height = this.addressTargetContainer.nativeElement.getBoundingClientRect().height;
    this.cWidth = this.addressDragContainer.nativeElement.getBoundingClientRect().width;
    this.cHeight = this.addressDragContainer.nativeElement.getBoundingClientRect().height;
    this.extractRegion();
  }

  public extractRegion(moveNext?: boolean): void {
    const data = {
      depositDir: this.depositDir,
      page: this.selectedPage,
      posX: this.posX * 210 / this.cWidth,
      posY: this.posY * 297 / this.cHeight,
      width: this.width * 210 / this.cWidth,
      height: this.height * 297 / this.cHeight,
    };
    this.createDepositService.extractExpressAddress(data).subscribe(response => {
      if (response && response.resultItems) {
        this.resultItems = response.resultItems;
      }
      if (response && response.postalAddress) {
        this.postalAddressLines = response.postalAddress;
        if (response.objAddress) {
          this.extractedAddress = new PostalAddress(response.objAddress);
        } else {
          this.extractedAddress = new PostalAddress({});
        }
        if (response.country) {
          this.selectedCountry = response.country;
        } else {
          this.selectedCountry = 'FRANCE';
        }
        this.setCountryProperties();
        if (moveNext && this.extractedAddress.isValid()) {
          this.nextStep();
        }
      }
    });
  }

  public setCountryProperties(): void {
    if (this.addressService.getLabelsForLang(this.translate.currentLang)) {
      this.buildCountryProperties();
    } else {
      this.addressService.labelsReady.subscribe(val => {
        if (val === this.translate.currentLang) {
          this.buildCountryProperties();
        }
      });
    }
  }

  buildCountryProperties() {
    this.addressesLines = [];
    this.formattedAddress = [];
    const countryKey = this.selectedCountry + ':NO-STATE';
    this.propertiesOfSelectedCountry = this.addressService.getPropertiesFromKey(countryKey);
    if (this.propertiesOfSelectedCountry) {
      if (this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID]) {
        this.countryLabel = this.addressItemsLabels.country[this.propertiesOfSelectedCountry.sIsoID];
      } else {
        this.countryLabel = {};
      }
      for (const adressLine of this.propertiesOfSelectedCountry.listFmtPostalAddr.listFmtPostalAdd) {
        const line = new AddressLine(adressLine);
        let key = line.sDataLib;
        if (key && key.indexOf('country.' + this.propertiesOfSelectedCountry.sIsoID) >= 0) {
          key = key.replace('country.' + this.propertiesOfSelectedCountry.sIsoID + '.', '');
        }
        if (this.countryLabel[key]) {
          line.sDataLibValue = this.countryLabel[key];
        }
        this.addressesLines.push(line);
      }
    }
    this.tryToBuildNonElemProperties();
    this.tryToBuildElemProperties();
    this.formatGlobalAdress();
  }

  public formatGlobalAdress(): void {
    this.formattedAddress = [];

    const tempoArray = [];

    for (const addressLine of this.addressesLines) {
      const index = addressLine.iLineNumber - 1;
      if (addressLine.sDataValue) {
        if (tempoArray[index]) {
          tempoArray[index] = tempoArray[index].concat(addressLine.sDataValue);
        } else {
          tempoArray[index] = addressLine.sDataValue;
        }
      }
    }

    for (const entry of tempoArray) {
      // Specific case: for france (we're not adding the country to the finalAddress)
      if (entry && entry !== COUNTRY_TO_EXCLUDE) {
        this.formattedAddress.push(entry);
      }

    }
  }

  private tryToBuildElemProperties(): void {
    if (this.extractedAddress.mElemByName) {
      const addresProperties = this.extractedAddress.mElemByName;

      const regexElem = '(addrElem)[0-9]+';
      const arrayFromParam = [];

      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '' && new RegExp(regexElem).test(property)) {
          arrayFromParam.push({property: property, value: addresProperties[property]});
        }
      }

      for (const addressLine of this.addressesLines) {
        for (const param of arrayFromParam) {
          if (addressLine.sDataName === param.property) {
            addressLine.sDataValue = param.value;
          }
        }

      }
    }
  }

  private tryToBuildNonElemProperties(): void {
    if (this.extractedAddress) {
      const addresProperties = this.extractedAddress.mElemByName;
      for (const property in addresProperties) {
        if (addresProperties.hasOwnProperty(property)) {
          if (addresProperties.hasOwnProperty(property) && addresProperties[property] !== '') {
            for (const addressLine of this.addressesLines) {
              const valueFromFold = addresProperties[property];
              if (addressLine.sDataName.includes(property) && property !== COUNTRY_LABEL_KEY) {
                addressLine.sDataValue = valueFromFold;
              }

            }
          }
        }
      }
    }
  }

  storeRecipient(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('recipient', JSON.stringify(
      {
        lines: this.extractedAddress.formatted,
        countryISOId: this.extractedAddress.sCountryID,
        elements: this.extractedAddress.mElemByName
      }));
    this.createDepositService.storeRecipients(dataToSend).subscribe(response => {
      if (response.recipientCount) {
        if (this.hasSignature) {
          this.currentStep = ExpressDepositComponent.FORMATTING_STEP;
        } else {
          setTimeout(() => {
            this.prepareUnitFinalFile();
          },600);
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  signaturePositionStored(stored: boolean) {
    if (stored) {
      this.prepareUnitFinalFile();
    }
  }

  prepareUnitFinalFile() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('grayColor', this.userGrayColor? 'Y' : 'N');
    this.createDepositService.prepareUnitFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        this.customizedFilePdf = response.pdfFile;
        if (this.currentStep !== ExpressDepositComponent.REVIEW_STEP) {
          this.currentStep = ExpressDepositComponent.REVIEW_STEP;
          this.activeIndex++;
        }
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  public loadVisualization(openModal: boolean): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.pdfToDisplay = URL.createObjectURL(blob);
        this.openVisualization = openModal;
      }
    }
  }

  /*b64toBlob(b64Data, contentType = 'application/pdf', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }*/

  public saveExpressDeposit(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.displayLoading = true;
    this.checkProgress();
    this.createDepositService.saveExpressDeposit(dataToSend).subscribe(response => {
      this.displayLoading = false;
      clearInterval(this.progressTimeout);
      if (response.serialLotDepot) {
        this.depositPersistedSerialLot = response.serialLotDepot;
      }
      if (response.foldCount) {
        this.persistedCount = response.foldCount;
        if (this.persistedCount > 0) {
          this.depositPersisted = true;
          this.closeLoader();
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_MSG')
        });
      }
    });
  }

  checkProgress() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.progressTimeout = setInterval(() => {
      this.createDepositService.checkExpressDepositProgress(dataToSend).subscribe(response => {
        if (response.trial) {
          this.savingTrial = response.trial;
        }
        if (response.progress) {
          this.progressPersisted = response.progress;
        }
        if (response.serialLotDepot) {
          this.depositPersistedSerialLot = response.serialLotDepot;
        }
        if (response.status && (response.status === 'FINISHED' || response.status === 'FAILED' || response.status === 'NOT_FOUND')) {
          clearInterval(this.progressTimeout);
        }
      });
    }, 1000);
  }

  closeLoader() {
    this.displayLoading = false;
    this.createDepositService.runningExpressDeposit.emit(this.depositDir);
    this.modalDisplay.emit(false);
  }

  editUnitAddress() {
    this.addressToEdit = this.extractedAddress;
    if (this.extractedAddress && this.extractedAddress.formatted) {
      this.addressToEditLines = this.extractedAddress.formatted;
    }
    else {
      this.addressToEditLines = [];
    }
    setTimeout(() => {
      this.showEditAddress = true;
    }, 100);
  }

  public updateUnitAddress(address) {
    this.extractedAddress.formatted = address.fa;
    this.extractedAddress.valid = true;
    this.extractedAddress.fields.country = address.country;
    this.extractedAddress.sCountryID = address.countryID;
    this.extractedAddress.fields.country.replace(':NO-STATE', '');
    this.showEditAddress = false;
  }

  handleDestAddressClose() {
    this.showEditAddress = false;
    if (this.userEditedAddress) {
      this.doCreateNewModel(this.extractedAddress.formatted);
    }
  }
  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }

  closeEditor() {
    this.editorClosed();
  }

  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;
}
